import React, {ElementType, ReactNode} from 'react';

import Heading from '../../../atoms/Heading/Heading.react';
import './supertitle.scss';

export interface Props {
  as?: ElementType;
  children: ReactNode;
}

export const Supertitle = ({as, children, ...rest}: Props) => (
  <Heading size='xxs' className='o-wall-supertitle' as={as} {...rest}>
    {children}
  </Heading>
);
